import Cookies from 'js-cookie'
import {getPostSlug, isReformLp, isRebuildLp, isLoanLp} from './utils'
import config from './config.json'


// どの経路から流入してきたのかという情報をLPに引き継ぐため、流入経路の情報を一定期間保持する
class OverrideParamsStore {
  overridableParams() {
    return ['utm_source', 'utm_campaign', 'utm_content', 'utm_medium', 'utm_term']
  }

  expiredAt() {
    // ユーザーの97.7%はセッション継続時間が1時間以内であるため、1時間あれば十分。
    return new Date(new Date().getTime() + 60 * 60 * 1000)
  }

  setParams(params) {
    Object.keys(this.permittedParams(params)).forEach((key) => {
      Cookies.set(key, params[key], {
        expires: this.expiredAt(),
      })
    })
  }

  getParams() {
    const overridableParams = this.overridableParams()
    return overridableParams.reduce((ret, param) => {
      const stored = Cookies.get(param)
      if (stored === undefined) return ret
      return {...ret, [param]: stored}
    }, {})
  }

  permittedParams(params) {
    const overridableParams = this.overridableParams()
    return Object.keys(params)
      .filter((param) => overridableParams.includes(param))
      .reduce((ret, param) => {
        return {...ret, [param]: params[param]}
      }, {})
  }
}


export class LpRewriter {
  // fixme: ifが多すぎる。設定ファイルに置き換えリストか置き換え条件の正規表現を記載してそのルールを単純に実行する仕組みに変えたい
  constructor(postSlug, overrideParams) {
    this.postSlug = postSlug
    this.overrideParams = overrideParams
  }

  rewrite(url) {
    const isReformLpUrl = isReformLp(url)
    const isRebuildLpUrl = isRebuildLp(url)
    const isLoanLpUrl = isLoanLp(url)

    if (!(isReformLpUrl || isRebuildLpUrl || isLoanLpUrl)) return url

    const uri = this.toUri(url)
    uri.pathname = this.rewritePath(url, true)

    // どの記事からの流入か把握するためにutm_termの値は基本的に記事のslugを設定する
    uri.searchParams.set("utm_term", this.postSlug)

    Object.keys(this.overrideParams).forEach((key) => {
      uri.searchParams.set(key, this.overrideParams[key])
    })

    const notContainDomain = url.startsWith('/')
    if (notContainDomain) return uri.pathname + '?' + uri.searchParams.toString()
    return uri.toString()
  }

  rewritePath(url, pathOnly = false) {
    const uri = this.toUri(url)

    const isReformLpUrl = isReformLp(url)
    const isRebuildLpUrl = isRebuildLp(url)
    const isLoanLpUrl = isLoanLp(url)

    if (!(isReformLpUrl || isRebuildLpUrl)) return this.toUrl(uri, pathOnly)
    if (isLoanLpUrl) return this.toUrl(uri, pathOnly)
    if (this.isReplacementExclusionPath(uri.pathname)) return this.toUrl(uri, pathOnly)

    // 最新のLPのリンクに差し替え
    if (isReformLpUrl) {
      uri.pathname = config.lp.reform.path
    }
    if (isRebuildLpUrl) {
      uri.pathname = config.lp.rebuild.path
    }

    return this.toUrl(uri, pathOnly)
  }

  isReplacementExclusionPath(path) {
    return config.replacement_exclusion_list.includes(path)
  }

  toUri(url) {
    let dummyBase = url.startsWith('/') ? 'http://hapisumu.jp/' : undefined // パスのみの時にはURLはインスタンス化できないので仮のドメインを設定する
    return new URL(url, dummyBase)
  }

  toUrl(uri, pathOnly = false) {
    if (pathOnly) return uri.pathname
    return uri.toString()
  }
}

export function rewriteLpLinks() {
  const queryParams = new URL(window.location.href).searchParams
  const store = new OverrideParamsStore()
  store.setParams(queryParams)
  const overrideParams = store.getParams()

  const rewriter = new LpRewriter(getPostSlug(), overrideParams)

  Array.from(document.getElementsByTagName('a')).forEach(function (a) {
    a.href = rewriter.rewrite(a.href)
  })
}

export function rewriteFormUtmInput() {
  const queryParams = new URL(window.location.href).searchParams;
  const store = new OverrideParamsStore();
  store.setParams(queryParams);
  const overrideParams = store.getParams();

  const forms = document.querySelectorAll('.reform-lp-form');
  if (!forms.length) return;

  const rewriter = new LpRewriter(getPostSlug(), overrideParams);

  function setOrCreateHiddenInput(form, name, value) {
    let input = form.querySelector(`input[name="${name}"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = value;
  }

  forms.forEach(form => {
    form.action = rewriter.rewritePath(form.action);

    if (overrideParams.utm_source) {
      setOrCreateHiddenInput(form, 'utm_source', overrideParams.utm_source || 'press');
    }
    if (overrideParams.utm_term) {
      setOrCreateHiddenInput(form, 'utm_term', overrideParams.utm_term);
    }
    if (overrideParams.utm_medium) {
      setOrCreateHiddenInput(form, 'utm_medium', overrideParams.utm_medium);
    }
    if (overrideParams.utm_campaign) {
      setOrCreateHiddenInput(form, 'utm_campaign', overrideParams.utm_campaign);
    }

    Object.keys(overrideParams)
        .filter(param => !['utm_source', 'utm_term', 'utm_medium', 'utm_campaign'].includes(param))
        .forEach(param => {
          setOrCreateHiddenInput(form, param, overrideParams[param]);
        });
  });
}
